module.exports = __webpack_public_path__ + "img/black_img.dbcddd66.png";